import { Card, Container, Group, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import { IconShieldSearch } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";
import CandidatePicker from "../components/CandidatePicker";
import { useEnrichmentCostBasis } from "../hooks/useEnrichmentCostBasis";
import { creditPrice } from "../_Shared/enrichment";

export default function ToolsPage() {
  const { t, i18n } = useTranslation("Veft");
  const [, setLocation] = useLocation();
  const costBasis = useEnrichmentCostBasis();
  const credits = costBasis?.backgroundCheckCredits ?? 2000;
  const price = creditPrice(costBasis, credits, i18n.language);

  return (
    <Container size="md" py="md">
      <Stack gap="lg">
        <div>
          <Title order={3}>{t("nav_tools")}</Title>
          <Text size="sm" c="dimmed" mt={4}>{t("tools_intro")}</Text>
        </div>
        <Card withBorder p="md">
          <Stack gap="sm">
            <Group gap="sm">
              <ThemeIcon variant="light" size="lg" color="blue">
                <IconShieldSearch size={18} />
              </ThemeIcon>
              <div>
                <Text fw={600}>{t("bg_title")}</Text>
                <Text size="sm" c="dimmed">{t("bg_intro")}</Text>
              </div>
            </Group>
            {price && <Text size="xs" c="dimmed">{t("bg_cost", { credits, price })}</Text>}
            <Text size="sm">{t("tools_bg_pick")}</Text>
            <CandidatePicker
              size="sm"
              placeholder={t("search_candidates")}
              onSelect={(c) => setLocation(`/candidates/${c.id}?tab=background`)}
            />
          </Stack>
        </Card>
      </Stack>
    </Container>
  );
}
